import axios from "axios";
import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import "../report-styles/UploadFile.styles.scss";
import UploadIcon from "../svgs/upload.svg";
import Tooltip from "@material-ui/core/Tooltip";

//import uploadImage from "../../../img/kyc/upload/Approved.svg";
import { useNotification } from "../../Notifications/NotificationProvider";

import UploadConfirmationModal from "./uploadConfirmationModal";

const UploadFile = ({
  heading,
  help,
  imageFile,
  api,
  styles,
  varients = [],
  eMail,
  isEmailRequired,
  feedbackResponse,
  callBack,
  tag,
}) => {
  const [modal, set_modal] = useState(false);
  const [uploading, set_uploading] = useState(false);
  const [response, set_response] = useState("");
  const [downloading, setDownloading] = useState(false);
  const dispatchNotification = useNotification();
  const [queryParams, setQueryParams] = useState({});
  const getErrorResponse = async (err) => {
    const fallbackMessage = "Upload failed. Please try again.";

    const response = err?.response;

    if (!response) {
      return {
        is_error: 1,
        message: err?.message || fallbackMessage,
      };
    }

    let data = response.data;
    if (data instanceof Blob) {
      try {
        data = JSON.parse(await data.text());
      } catch {
        data = { message: await data.text() };
      }
    }

    const message =
      response.status === 403
        ? fallbackMessage
        : typeof data === "string"
          ? data.trim() || fallbackMessage
          : data?.message || data?.error || data?.detail || fallbackMessage;

    return {
      ...(typeof data === "object" ? data : {}),
      is_error: 1,
      message,
    };
  };

  const onDrop = useCallback(
    (acceptedFiles) => {
      uploadFile(acceptedFiles[0]);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [queryParams, eMail]
  );

  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    accept:
      "text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    init: function () {
      this.on("addedfile", function (file) {
        if (!file.type) {
          var ext = file.name.split(".").pop();
          console.log("extension: " + ext);
          if (ext === "xls") {
            Object.defineProperty(file, "type", {
              value: "application/vnd.ms-excel",
            }); // MIME type
          }
        }
      });
    },
    onDrop,
  });

  const uploadFile = (file) => {
    set_modal(false);
    set_uploading(true);
    const formData = new FormData();

    formData.append("file", file);
    if ((isEmailRequired && eMail) || (tag && eMail))
      formData.append("email", eMail);
    if (tag) formData.append("tag", tag);

    const apiUrl =
      api === "/bulk-location-correction"
        ? `${process.env.REACT_APP_API_URL}/api/payment_speaker/upload${api}`
        : `${process.env.REACT_APP_API_URL}/api/uploads/v1${api}`;
    const options = {
      params: queryParams,
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
      },
    };
    if (feedbackResponse) {
      options.responseType = "blob";
    }
    axios
      .post(apiUrl, formData, options)
      .then((res) => {
        set_response(res.data);
        if (isEmailRequired && !!callBack) callBack();
        if (feedbackResponse && res.data instanceof Blob) {
          downloadFeedbackFile(res.data, heading);
        }
      })
      .catch(async (err) => {
        const error = await getErrorResponse(err);

        dispatchNotification({
          type: "ERROR",
          message: error.message,
        });

        set_response(error);
      })
      .finally(() => {
        set_uploading(false);
        set_modal(true);
      });
  };

  const downloadFeedbackFile = (blob, title) => {
    setDownloading(true);
    try {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `FEEDBACK_${title}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      dispatchNotification({
        type: "ERROR",
        message: "Failed to download feedback file",
      });
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div>
      <div {...getRootProps({})} style={{ ...styles }}>
        <input {...getInputProps()} />
        {isEmailRequired ? (
          <div
            style={{
              display: "flex",
              width: 160,
              height: 40,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Upload
            <img
              className="upload-icon"
              src={UploadIcon}
              alt="Upload Icon"
              style={{ marginLeft: 10 }}
            />
          </div>
        ) : (
          <Tooltip arrow title="Upload" placement="top">
            <img className="upload-icon" src={UploadIcon} alt="Upload Icon" />
          </Tooltip>
        )}
      </div>
      {uploading && <ProgressLoader />}
      <UploadConfirmationModal
        show={modal}
        handleHide={() => {
          set_modal(false);
        }}
        data={response}
      />
    </div>
  );
};

const ProgressLoader = () => (
  <div className="progress" style={{ margin: 0, backgroundColor: "#e2146e63" }}>
    <div className="indeterminate" style={{ backgroundColor: "#e2146e" }}></div>
  </div>
);

export default UploadFile;
